<template>
  <div class="home" v-if="pageBlocks">
    <!-- banner carousel -->
    <section class="row gx-md-0 mb-5" v-if="topBanners">
      <div class="col-12 gx-0">
        <div class="to-fade-in-upward">
          <div id="carousel-top-banner" class="carousel slide" data-bs-ride="carousel">
            <div class="carousel-indicators top-carousel-indicators mb-0">
              <button type="button" v-for="(banner, index) in topBanners" :key="`top-bn-indicator-${index}`" data-bs-target="#carousel-top-banner" :data-bs-slide-to="index" class="carousel-indicator-item" :class="{ active: index === 0 }" aria-current="true" :aria-label="`Slide ${index + 1}`"></button>
            </div>
            <div class="carousel-inner">
              <div v-for="(banner, index) in topBanners" :key="`top-bn-content-${index}`" class="carousel-item" :class="{ active: index === 0 }">
                <div class="top-banner position-relative">
                  <a v-if="banner.redirectUrl" :href="banner.redirectUrl" target="_blank">
                    <div class="image d-none d-md-block" :style="util.getImageStyle(banner.imgPath)"></div>
                    <div class="image d-block d-md-none" :style="util.getImageStyle(banner.mobileImgPath ? banner.mobileImgPath : banner.imgPath)"></div>
                    <div class="position-absolute text-light text-uppercase p-3 mb-2 bn-carousel-title" v-html="util.getHtml(banner.title)"></div>
                  </a>
                  <router-link v-else-if="banner.goodsArray" :to="`/w/product/collect/${banner.id}`">
                    <div class="image d-none d-md-block" :style="util.getImageStyle(banner.imgPath)"></div>
                    <div class="image d-block d-md-none" :style="util.getImageStyle(banner.mobileImgPath ? banner.mobileImgPath : banner.imgPath)"></div>
                    <div class="position-absolute text-light text-uppercase p-3 mb-2 bn-carousel-title" v-html="util.getHtml(banner.title)"></div>
                  </router-link>
                </div>
              </div>
            </div>
            <!--
            <button class="carousel-control carousel-control-prev" type="button" data-bs-target="#carousel-top-banner" data-bs-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control carousel-control-next" type="button" data-bs-target="#carousel-top-banner" data-bs-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Next</span>
            </button>
            -->
          </div>
        </div>
      </div>
    </section>
    <!-- title -->
    <section class="row mb-5">
      <!-- 首頁的 slogan 就是主標題，包成 h1 讓語意正確(視覺不變，h1 的預設樣式已在下方歸零)。
           alt 同時提供給搜尋引擎與螢幕閱讀器，圖片本身是文字圖無法被讀取。 -->
      <h1 class="col-12 text-center to-fade-in-upward home-title">
        <img class="pt-5 pb-5 img-title d-none d-md-inline-block" src="@/assets/img/home-title-tw.svg" alt="Loft29 北歐設計傢俱・燈飾選物">
        <!-- 手機版改用裁掉四周留白的版本，同樣寬度下字約放大 1.6 倍 -->
        <img class="pt-5 pb-5 img-title d-md-none" src="@/assets/img/home-title-tw-mobile.svg" alt="Loft29 北歐設計傢俱・燈飾選物">
      </h1>
    </section>

    <template v-for="(section, indexSection) in sections">
      <!-- banner col1 -->
      <section v-if="section.type === 'banner' && section.items.length === 1" :key="`bn1-${section.id}`" class="row gx-md-0 mb-5 bn1 bg-solid">
        <div v-for="(item, indexItem) in section.items" :key="`bn1-${section.id}-${indexItem}`" class="col-lg-12 gx-0">
          <div class="position-relative to-fade-in-upward hover-mask">
            <a v-if="item.redirectUrl" :href="item.redirectUrl" target="_blank">
              <div class="image" :style="util.getImageStyle(item.imgPath)"></div>
              <div class="position-absolute top-0 start-0 p-3">
                <div class="col1-bn-title text-light">{{ item.title }}</div>
                <div class="col1-bn-subtitle text-light">{{ item.subTitle }}</div>
              </div>
            </a>
            <router-link v-else-if="item.goodsArray" :to="`/w/product/collect/${item.id}`">
              <div class="image" :style="util.getImageStyle(item.imgPath)"></div>
              <div class="position-absolute top-0 start-0 p-3">
                <div class="col1-bn-title text-light">{{ item.title }}</div>
                <div class="col1-bn-subtitle text-light">{{ item.subTitle }}</div>
              </div>
            </router-link>
          </div>
        </div>
      </section>
      <!-- banner col2 -->
      <section v-else-if="section.type === 'banner' && section.items.length === 2" :key="`bn2-${section.id}`" class="row gx-md-0 mb-5 bn2 bg-solid">
        <div v-for="(item, indexItem) in section.items" :key="`bn2-${section.id}-${indexItem}`" class="col-lg-6 gx-0">
          <div class="position-relative to-fade-in-upward hover-mask">
            <a v-if="item.redirectUrl" :href="item.redirectUrl" target="_blank">
              <div class="image" :style="util.getImageStyle(item.imgPath)"></div>
              <div class="position-absolute top-0 start-0 p-3">
                <div class="col2-bn-title text-light">{{ item.title }}</div>
                <div class="col2-bn-subtitle text-light">{{ item.subTitle }}</div>
              </div>
            </a>
            <router-link v-else-if="item.goodsArray" :to="`/w/product/collect/${item.id}`">
              <div class="image" :style="util.getImageStyle(item.imgPath)"></div>
              <div class="position-absolute top-0 start-0 p-3">
                <div class="col2-bn-title text-light">{{ item.title }}</div>
                <div class="col2-bn-subtitle text-light">{{ item.subTitle }}</div>
              </div>
            </router-link>
          </div>
        </div>
      </section>
      <!-- banner col3 -->
      <section v-else-if="section.type === 'banner' && section.items.length === 3" :key="`bn3-${section.id}`" class="row gx-md-0 mb-5 bn3 bg-solid">
        <div v-for="(item, indexItem) in section.items" :key="`bn2-${section.id}-${indexItem}`" class="col-lg-4 gx-0">
          <div class="position-relative to-fade-in-upward hover-mask">
            <a v-if="item.redirectUrl" :href="item.redirectUrl" target="_blank">
              <div class="image" :style="util.getImageStyle(item.imgPath)"></div>
              <div class="position-absolute top-0 start-0 p-3">
                <div class="col3-bn-title text-light">{{ item.title }}</div>
                <div class="col3-bn-subtitle text-light">{{ item.subTitle }}</div>
              </div>
            </a>
            <router-link v-else-if="item.goodsArray" :to="`/w/product/collect/${item.id}`">
              <div class="image" :style="util.getImageStyle(item.imgPath)"></div>
              <div class="position-absolute top-0 start-0 p-3">
                <div class="col3-bn-title text-light">{{ item.title }}</div>
                <div class="col3-bn-subtitle text-light">{{ item.subTitle }}</div>
              </div>
            </router-link>
          </div>
        </div>
      </section>
      <!-- products -->
      <section v-else-if="section.type === 'product'" :key="`product-${section.id}`" class="mb-5">
        <horizontal-product-list :id="`product-list-${section.id}`" :title="section.title" :subtitle="section.subTitle" :productIds="section.productIds" :view-all="section.items.length ? `/w/product/collect/${section.items[0].id}` : null"/>
      </section>
      <!-- icons -->
      <section class="pb-5 bg-solid" v-if="indexSection + 1 === parseInt(sections.length / 2)" :key="`icon-${indexSection}`">
        <div class="row mt-5 border-top border-secondary">
          <div class="col-md-3 col-6 mt-5 text-center">
            <div><img class="icon-img" src="@/assets/img/ic-delivery.svg"></div>
            <div class="mt-3 icon-text">全台運送</div>
          </div>
          <div class="col-md-3 col-6 mt-5 text-center">
            <div><img class="icon-img" src="@/assets/img/ic-tag.svg"></div>
            <div class="mt-3 icon-text">會員專屬折扣</div>
          </div>
          <div class="col-md-3 col-6 mt-5 text-center">
            <div><img class="icon-img" src="@/assets/img/ic-credit-card.svg"></div>
            <div class="mt-3 icon-text">安全支付</div>
          </div>
          <div class="col-md-3 col-6 mt-5 text-center">
            <div><img class="icon-img" src="@/assets/img/ic-store.svg"></div>
            <div class="mt-3 icon-text">專業諮詢與服務</div>
          </div>
        </div>
      </section>
    </template>

    <!-- journal -->
    <section v-if="journals" class="mb-5 bg-solid journal">
      <div class="p-3 border border-secondary">
        <div id="carousel-journal" class="carousel slide" data-bs-ride="carousel">
          <div class="carousel-inner">
            <template v-for="(item, index) in journals">
              <router-link v-if="index < 4" :key="`journal-content-${index}`" :to="`/w/journal/detail/${item.articleId}`" target="_blank" class="carousel-item text-dark text-decoration-none" :class="{ active: index === 0 }">
                <div class="row">
                  <div class="col-md-8">
                    <template v-if="item.mobileImg">
                      <div class="image d-none d-md-block" :style="util.getImageStyle(item.originalImg)"></div>
                      <div class="mobile-image d-md-none" :style="util.getImageStyle(item.mobileImg)"></div>
                    </template>
                    <div v-else class="image" :style="util.getImageStyle(item.originalImg)"></div>
                  </div>
                  <div class="col-md-4">
                    <div class="title to-fade-in-upward mb-5">{{ item.title }}</div>
                    <div class="mt-3 content to-fade-in-leftward" v-html="util.getHtmlText(item.content)"></div>
                    <div class="mt-3 mb-1 more more-position d-flex align-items-center text-decoration-underline"><small>Read more</small></div>
                  </div>
                </div>
              </router-link>
            </template>
          </div>
          <div class="carousel-indicators journal-carousel-indicators mt-2">
            <template v-for="(item, index) in journals">
              <button v-if="index < 4" :key="`journal-indicator-${index}`" type="button" data-bs-target="#carousel-journal" :data-bs-slide-to="index" class="carousel-indicator-item" :class="{ active: index === 0 }" aria-current="true" :aria-label="`Slide ${index + 1}`"></button>
            </template>
          </div>
        </div>
      </div>
    </section>

    <!-- subscribe edm -->
    <!--section class="row mb-5 pt-3 pb-3 justify-content-center subscribe-edm">
      <div class="col-12 text-center title">訂閱最新優惠訊息！</div>
      <div class="col-md-4 col-8 text-center mt-4">
        <input type="email" class="form-control" placeholder="請輸入您的 E-mail">
      </div>
      <div class="col-md-2 col-4 text-center mt-4">
        <button class="btn btn-dark w-100">立即訂閱</button>
      </div>
    </section-->
    <section id="main-bg">
      <div class="position-relative w-100 h-100">
        <div class="shape circle"></div>
        <div class="shape square"></div>
      </div>
    </section>
  </div>
</template>

<script>
import constant from '@/constant.js'
import util from '@/util.js'
import commonApi from '@/api/common.js'
import journalApi from '@/api/journal.js'
import HorizontalProductList from '@/components/Product/HorizontalProductList.vue'
import { mapMutations } from 'vuex'

export default {
  name: 'Home',
  components: {
    HorizontalProductList
  },
  data: function () {
    return {
      pageBlocks: null,
      journals: null
    }
  },
  computed: {
    util: function () {
      return util
    },
    topBanners: function () {
      if (!this.pageBlocks) {
        return null
      }
      var banners = this.pageBlocks.filter(e => e.type === 'carousel')
      if (banners) {
        banners.sort((a, b) => (a.sortOrder - b.sortOrder))
      }
      return banners
    },
    sections: function () {
      if (!this.pageBlocks) {
        return null
      }
      var ret = []
      this.pageBlocks.forEach(e => {
        if (e.type !== 'carousel') {
          var group = ret.find(g => (g.id === e.groupId && g.type === e.type))
          if (group) {
            group.items.push(e)
          } else {
            var item = { id: e.groupId, type: e.type, items: [e] }
            if (e.type === 'product' && e.goodsArray) {
              item.title = e.title
              item.subTitle = e.subTitle
              item.productIds = e.goodsArray.split(',')
            }
            ret.push(item)
          }
        }
      })
      ret.forEach(e => { e.items.sort((a, b) => (a.sortOrder - b.sortOrder)) })
      return ret
    }
  },
  mounted: function () {
    this.apiGetPageBlocks()
    this.apiGetJournals()
  },
  methods: {
    ...mapMutations([
      'signOut'
    ]),
    apiGetPageBlocks: function () {
      var self = this
      commonApi.getPageBlocks(function (err, rspData) {
        if (err) {
          if (err === constant.API_ERR_AUTH) {
            self.signOut()
          } else {
            alert(`${err}: ${rspData}`)
          }
          return
        }
        self.pageBlocks = rspData
        self.$nextTick().then(() => {
          self.$emit('animate')
        })
      })
    },
    apiGetJournals: function () {
      var self = this
      journalApi.getJournals(null, function (err, rspData) {
        if (err) {
          if (err === constant.API_ERR_AUTH) {
            self.signOut()
          } else {
            alert(`${err}: ${rspData}`)
          }
          return
        }
        self.journals = rspData
      })
    }
  }
}
</script>

<style scoped>
.img-title {
  max-width: 100%;
  padding-left: 1rem;
  padding-right: 1rem;
}
/* slogan 改用 h1 後要歸零瀏覽器預設的 margin 與字級，維持原本外觀 */
.home-title {
  margin: 0;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
}
.bn-carousel-title {
  bottom: 0;
  left: 0;
  font-family: 'Noto Serif TC', serif;
  font-size: 4rem;
  font-weight: 700;
  line-height: 1;
}

.col1-bn-title {
  font-family: 'Noto Serif TC', serif;
  font-size: 2.9rem;
  font-weight: 700;
}
.col1-bn-subtitle {
  font-family: 'Noto Serif TC', serif;
  font-size: 2.3rem;
}

.col2-bn-title {
  font-family: 'Noto Serif TC', serif;
  font-size: 2.8rem;
  font-weight: 700;
}
.col2-bn-subtitle {
  font-family: 'Noto Serif TC', serif;
  font-size: 2.2rem;
}

.col3-bn-title {
  font-family: 'Noto Serif TC', serif;
  font-size: 2.4rem;
  font-weight: 700;
}
.col3-bn-subtitle {
  font-family: 'Noto Serif TC', serif;
  font-size: 1.8rem;
}

.icon-img {
  width: 84px;
  height: 84px;
}
.icon-text {
  font-size: 1.25rem;
  font-family: 'Noto Serif TC', serif;
}

.journal .title {
  font-size: 28px;
  font-weight: 700;
  font-family: 'Noto Serif TC', serif;
}
.journal .content {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.journal .image {
  width: 100%;
  padding-bottom: 60%;
}
.journal .mobile-image {
  width: 100%;
  padding-bottom: 130%;
}

.subscribe-edm .title {
  font-size: 1.9rem;
  font-weight: 700;
  font-family: 'Noto Serif TC', serif;
}

.top-banner .image {
  width: 100%;
  padding-bottom: 42.5vw;
  margin: auto;
}
.bn1 .image {
  width: 100%;
  padding-bottom: 60%;
}
.bn2 .image {
  width: 100%;
  padding-bottom: 100%;
}
.bn3 .image {
  width: 100%;
  padding-bottom: 150%;
}

/* carousels */
.carousel-indicator-item {
  width: 8px;
  height: 8px;
  background-color: #6e6e6e;
  opacity: 1;
}
.carousel-indicator-item.active {
  background-color: var(--loft-color);
}
/*
.carousel-control {
  width: 8%;
}
.top-carousel-indicators {
  justify-content: right;
  margin: 8px;
}
#carousel-journal .carousel-control {
  height: 90%;
}
*/
.journal-carousel-indicators {
  display: inline-block;
  bottom: 0;
  right: 0;
  left: unset;
  margin: 0;
}
.journal .more:before {
  content: url("~@/assets/img/ic-step-divider.svg");
  padding-right: 4px;
}
.journal .more-position {
  position: absolute;
  bottom: 0;
}

/* background graph */
#main-bg {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: -100;
}
.shape {
  position: absolute;
  width: 70vw;
  height: 70vw;
  border: 1px solid #907070;
  opacity: .5;
}
.circle {
  border-radius: 100%;
  transform-origin: 100% 100%;
  top: -20vw;
  right: -30vh;
  animation: animation-circle 60s infinite;
}
.square {
  left: -20vw;
  bottom: -30vh;
  animation: animation-square 60s infinite alternate;
}
@keyframes animation-circle {
  50% {
    transform: rotate(-35deg);
  }
}
@keyframes animation-square {
  0% {
    transform: rotate(-70deg);
  }
  70%,100% {
    transform: rotate(-140deg);
  }
}

@media screen and (max-width: 767px) {
  /* 手機版 slogan 放大：拿掉左右內距，並用負 margin 抵銷 row gutter，讓 SVG 撐滿螢幕寬度 */
  .img-title {
    display: block;
    max-width: none;
    width: calc(100% + var(--bs-gutter-x, 1.5rem));
    padding-left: 0;
    padding-right: 0;
    margin-left: calc(var(--bs-gutter-x, 1.5rem) * -0.5);
    margin-right: calc(var(--bs-gutter-x, 1.5rem) * -0.5);
  }
  .top-banner .image {
    padding-bottom: calc(100vh - 75px);
  }
  .bn-carousel-title {
    font-size: 2.3rem;
  }
  .bn1 .image {
    padding-bottom: calc(100vh - 75px);
  }
  .journal .more-position {
    position: relative;
    bottom: unset;
  }
  .journal .content {
    display: none;
  }
}
</style>
